import { render, staticRenderFns } from "./RenameColumn.vue?vue&type=template&id=adfcc58c&scoped=true&"
import script from "./RenameColumn.vue?vue&type=script&lang=js&"
export * from "./RenameColumn.vue?vue&type=script&lang=js&"
import style0 from "./RenameColumn.vue?vue&type=style&index=0&id=adfcc58c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfcc58c",
  null
  
)

export default component.exports